<app-page-header [title]="'Questionnaire'"></app-page-header>


<div class="main-container">

  <div class="card">
    <div class="card-header card-header-container" *ngIf="questionnaire_model.id">
      <div>{{questionnaire_model.questionnaire_template_name}}</div>
      <span class="remarks">Please provide the information requested in each tab below</span>
      <div class="card-header-button-container">
        <button kendoButton [primary]="true" [disabled]="is_read_only" [icon]="'save'" type="submit" (click)="submit('1')">Save Draft</button>
        <button kendoButton [primary]="true" [icon]="'check'" [disabled]="is_read_only" type="submit" (click)="submit('2')">Submit</button>
        <audit-history [search]="audit_search"></audit-history>
      </div>
    </div>
    <div class="card-body">
      <form [formGroup]="form">



        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Status</label>
          <div class="col-sm-8">
            <kendo-stepper
            [steps]="steps"
            [stepType]="stepType"
            [currentStep]="current_status"
            class="read-only"
          >
          <ng-template kendoStepperLabelTemplate let-step>
            <div class="stepper-label" *ngIf="step.is_progress" class="stepper-label-active" [ngClass]="[step.q_status]"><span >{{ step.label }}</span><span class="{{ step.icon }}"></span></div>
            <div class="stepper-label" *ngIf="!step.is_progress"><span >{{ step.label }}</span><span class="{{ step.icon }}"></span></div>
          </ng-template>
          </kendo-stepper>
          </div>
        </div>

        <div class="form-group row" *ngIf="questionnaire_model?.additional_note">
          <label class="col-sm-2 col-form-label">Notes</label>
          <div  class="additional-note" [innerHTML]="questionnaire_model?.additional_note" ></div>
        </div>

      </form>
      <nexus-form-result [model]="form_result"></nexus-form-result>
    </div>
  </div>


<ng-container>
  <div class="mb-3">

    <kendo-tabstrip class="kendo-tab">

      <kendo-tabstrip-tab title="{{panel.section_name}}" [selected]="i==0" *ngFor="let panel of questionnaire_form_panels;index as i">
        <ng-template kendoTabContent>
        <div class="container" [ngClass]="{ 'read-only': is_read_only}">
          <ng-container *ngFor="let field of panel.fields">
            <ng-container *ngTemplateOutlet="field_types; context: { field: field }"></ng-container>
          </ng-container>
        </div>
      </ng-template>
      </kendo-tabstrip-tab>

    </kendo-tabstrip>
    <div class="pt-3"><span class="required-style">* Mandatory field</span></div>
  <ng-template #field_types let-field="field" let-id="id">
    <ng-container [ngSwitch]="field.type">
      <ng-container *ngSwitchCase="'maskinput'">
        <ng-container *ngTemplateOutlet="mask_text_field; context: { field: field, id: id}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'textbox'">
        <ng-container *ngTemplateOutlet="text_field; context: { field: field, id: id}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'textarea'">
        <ng-container *ngTemplateOutlet="text_area_field; context: { field: field, id: id}"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'number'">
        <ng-container *ngTemplateOutlet="numeric_text_field; context: { field: field, id: id }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'date'">
        <ng-container *ngTemplateOutlet="date_field; context: { field: field, id: id }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'dropdown'">
        <ng-container *ngTemplateOutlet="drop_down_field; context: { field: field, id: id }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'dropdown_template'">
        <ng-container *ngTemplateOutlet="drop_down_template_field; context: { field: field, id: id }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'table'">
        <ng-container *ngTemplateOutlet="table_field; context: { field: field, id: id }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'file_upload'">
        <ng-container *ngTemplateOutlet="file_upload; context: { field: field, id: id }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'empty_field'">
        <ng-container *ngTemplateOutlet="empty_field; context: { field: field, id: id }"></ng-container>
      </ng-container>
  </ng-container>
  </ng-template>

  <ng-template #iconTemplate let-tooltip="tooltip">
    <fa-icon *ngIf="tooltip" kendoTooltip [icon]="faInfoCircle" size="xs" [title]="tooltip" class="info-icon"></fa-icon>
  </ng-template>
  <ng-template #headerIconTemplate let-tooltip="tooltip">
    <fa-icon *ngIf="tooltip" kendoTooltip [icon]="faInfoCircle" size="xs" [title]="tooltip" class="header-info-icon"></fa-icon>
  </ng-template>

  <ng-template #text_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
        <span *ngIf="field.required == 'true'" class="required-style">*</span>
        <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
      </label>
      <input kendoTextBox type="text" class="form-control"  [formControlName]="id || field.id"/>
    </div>
  </ng-template>

  <ng-template #text_area_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
        <span *ngIf="field.required == 'true'" class="required-style">*</span>
        <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
      </label>
      <textarea kendoTextArea class="form-control w-100"    [formControlName]="id || field.id" rows="5"></textarea>
    </div>
  </ng-template>

  <ng-template #mask_text_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
        <span *ngIf="field.required == 'true'" class="required-style">*</span>
        <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
      </label>
      <kendo-maskedtextbox  [mask]="field.mask" [formControlName]="id || field.id">
      </kendo-maskedtextbox>
    </div>
  </ng-template>
  <ng-template #numeric_text_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
        <span *ngIf="field.required == 'true'" class="required-style">*</span>
        <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
      </label>
      <kendo-numerictextbox class="form-control" format="n0" [formControlName]="id || field.id"></kendo-numerictextbox>
    </div>
  </ng-template>

  <ng-template #date_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
        <span *ngIf="field.required == 'true'" class="required-style">*</span>
        <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
      </label>
      <kendo-datepicker  placeholder="Select a date ..." [format]="'MM/dd/yyyy'" [formControlName]="id || field.id"></kendo-datepicker>
    </div>
  </ng-template>

  <ng-template #drop_down_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
         <span *ngIf="field.required == 'true'" class="required-style">*</span>
         <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
        </label>
      <kendo-dropdownlist placeholder="Select a option" class="form-control" [data]="field.options" [popupSettings]="{ width: 'auto'}" [valuePrimitive]="true" [formControlName]="id || field.id">
      </kendo-dropdownlist>
    </div>
  </ng-template>

  <ng-template #drop_down_template_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
      <label [attr.for]="field.id" class="col-form-label" *ngIf="field.show_label!=false">{{ field.label }}
        <span *ngIf="field.required == 'true'" class="required-style">*</span>
        <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container>
      </label>
      <kendo-dropdownlist placeholder="Select a option" class="form-control" [data]="field.options" [popupSettings]="{ width: 'auto'}" [valuePrimitive]="true" [formControlName]="id || field.id" textField="text"
      valueField="text">
       <ng-template kendoDropDownListItemTemplate let-dataItem>
        <div class="dropdown-item-container">
          <div class="dropdown-item-text">{{ dataItem.text }}</div>
          <ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: dataItem.tooltip }"></ng-container>
        </div>
        </ng-template>
      </kendo-dropdownlist>
    </div>
  </ng-template>

  <ng-template #empty_field let-field="field" let-id="id">
    <div class="mb-3 col" [ngClass]="field.style ? field.style : 'item'" [formGroup]="questionnaire_form">
    </div>
  </ng-template>

  <ng-template #table_field let-field="field" let-id="id">
    <div class="mb-3 col">
      <label [attr.for]="field.id" class="col-form-label">{{ field.label }}</label>
        <table class="table-style">
          <thead>
          <tr>
            <th class="header-style" style="max-width:40px;padding-left:4px;">SN</th>
            <th class="header-style" style="min-width:150px;" *ngFor="let header of field.fields">
              {{header.label}} <ng-container *ngTemplateOutlet="headerIconTemplate; context: { tooltip: header.tooltip }"></ng-container>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="row-style" *ngFor="let num of [].constructor(field.repeat); let i = index">
            <td class="cell-style">{{i + 1}}</td>
            <td class="cell-style" *ngFor="let item of field.fields"><ng-container *ngTemplateOutlet="field_types; context: { field: item,id: item.id + '_'+ i }"></ng-container></td>
          </tr>
        </tbody>
        </table>


    </div>
  </ng-template>


  <ng-template #file_upload let-field="field" let-id="id">

    <table class="file-upload-tab">
        <thead>
          <tr class="file-upload-tab-col">
            <th class="file-upload-tab-col-deliverables">{{ field.label }}<ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: field.tooltip }"></ng-container></th>
            <th class="file-upload-tab-col-filename">File Name</th>
            <th class="file-upload-tab-col-uploaded-by">Uploaded By</th>
            <th class="file-upload-tab-col-template-download"><span>Template<ng-container *ngTemplateOutlet="headerIconTemplate; context: { tooltip: 'Download document template'}"></ng-container></span></th>
            <th class="file-upload-tab-col-notes"><span>Additional Notes<ng-container *ngTemplateOutlet="headerIconTemplate; context: { tooltip: 'Specify additional details for the documents shared'}"></ng-container></span></th>
            <th class="file-upload-tab-col-status">Status</th>
            <th class="file-upload-tab-col-action">Upload</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let file_upload_filed of field.fields" class="file-upload-tab-col">
            <td>{{file_upload_filed?.label}}<span *ngIf="file_upload_filed?.required == 'true'" class="required-style">*</span><ng-container *ngTemplateOutlet="iconTemplate; context: { tooltip: file_upload_filed.tooltip }"></ng-container></td>
            <td class="file_link"><nexus-file-link [file_model]="file_upload_filed?.value"></nexus-file-link></td>
            <td>{{file_upload_filed.value?.uploaded_by}}</td>
            <td class="file-upload-tab-col-template-download">
              <div class="file-link">
                <a style="cursor:pointer;"  [title]="file_upload_filed?.template_download?.name" *ngIf="file_upload_filed?.template_download?.id"  (click)="download_file(file_upload_filed.template_download)">
                  <fa-icon  size="lg" [icon]="faFileDownload"></fa-icon>
                </a>
              </div>
            </td>
            <td class="file-upload-tab-col-notes">
              <textarea kendoTextArea class="form-control w-100 custom-text-area" [placeholder]="file_upload_filed?.label=='Bill Images'?'If needed, paste Bill Image URLs in this Notes section.':''" (input)="update_notes(file_upload_filed,$event)" [value]="file_upload_filed.value?.notes || ''"></textarea>
            </td>
            <td>
              <ng-container *ngIf="file_upload_filed?.value?.id">
                <span>{{file_upload_filed.value?.status}}</span>
              </ng-container>
            </td>
            <td>
              <div class="file-upload-action">
                <button kendoButton [primary]="true" icon="upload" (click)="open_dialog('file_upload_dialog',file_upload_filed)" title="Upload {{file_upload_filed?.label}} file"></button>
                <button *ngIf="file_upload_filed?.value" kendoButton icon="trash" (click)="file_upload_clear(file_upload_filed)" title="Remove {{file_upload_filed?.label}} file"></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

  </ng-template>
</div>
</ng-container>

</div>

<kendo-dialog [title]="file_update_title" [width]="'40%'" resizable="true" *ngIf="DIALOGS['file_upload_dialog']" (close)="close_dialog('file_upload_dialog')">
  <div class="col-md-12">
    <form [formGroup]="form_upload">
          <nexus-form-file-input #file_input id="file-input" formControlName="file_id" [restrictions]="restrictions" [max_file_size]="max_file_size" (select)="onFileSelectError($event)"></nexus-form-file-input><br/>
          <ng-container *ngIf="!file_error_result.error_message"><span>{{file_size_error_message}}</span></ng-container>
          <nexus-form-result [model]="file_error_result"></nexus-form-result>
          <div class ="file-upload-footer">
            <button kendoButton  [primary]="false" (click)="file_upload_cancel(file_input)">Cancel</button>
            <button kendoButton icon="check" [primary]="true" [disabled]="!!file_error_result.error_message" (click)="file_upload_submit(file_input)">Submit</button>
          </div>
    </form>
  </div>
</kendo-dialog>

<kendo-dialog title="Validation Error(s)" [width]="'40%'" resizable="true" *ngIf="DIALOGS['error_dialog']" (close)="close_dialog('error_dialog')">
  <div class="col-md-12">
    <nexus-form-result [model]="validation_dialog_result"></nexus-form-result>
        <table class="table-style">
          <thead>
          <tr>
            <th class="header-style">Section Name</th>
            <th class="header-style">Field Name</th>
          </tr>
        </thead>
        <tbody>
          <tr class="row-style" *ngFor="let result of validation_result">
            <td class="cell-style">{{result.section_name}}</td>
            <td class="cell-style">{{result.label}}</td>
          </tr>
        </tbody>
      </table>
  </div>
</kendo-dialog>

